module.exports = __webpack_public_path__ + "img/lab-pdf-icon.5603bd81.svg";